<div class="stepperContainer">
  <div *ngFor="let step of steps; let i = index" class="stepWrapper">
    <div class="stepContainer">
      <div [class]="'stepNumber ' + ((currentStep >= i) ? 'stepNumberActive' : '')">
        <span *ngIf="currentStep <= i" class="text-sm">{{i + 1}}</span>
        <mat-icon *ngIf="currentStep > i" class="icon">check</mat-icon>
      </div>
      <div class="stepContent">
        <span [class]="'text-md ' + ((currentStep >= i) ? 'fw-normal' : 'fw-normal subtitleText')">{{step.title}}</span>
        <small *ngIf="step.subtitle" class="subtitleText">{{step.subtitle}}</small>
      </div>
    </div>
    <div *ngIf="i < steps.length - 1" class="stepHorizontalLine"></div>
  </div>
</div>
